import workspaceQuery from '../../../graphql/queries/sales/PickingBoxLineWorkspaceQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const PickingBoxLine: EntityType = {
  type: 'PickingBoxLine',
  title: 'Picking Box Lines',
  workspaceUrl: '/Sales/Picking/PickingBoxLine/Workspace/',
  workspace: workspaceQuery,
  screenReference: 'PICKING_BOX_LINE',
};

export default PickingBoxLine;
